<template>
  <div>
    <app-navbar/>
    <v-content>
        <v-container fluid>
          Page Admin
        </v-container>
    </v-content>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Navbar from '@/components/comps/Navbar.vue'
import Footer from '@/components/comps/Footer.vue'
import router from "@/plugins/router";
export default {
  name: "Admin",
  mounted() {
    this.checkLoggedIn();
  },
  components: {
    'app-navbar' : Navbar,
    'app-footer' : Footer,
  },
  methods: {
    checkLoggedIn() {
      this.$session.start();
      if (!this.$session.has("token")) {
        router.push("/auth");
      }
    }
  }
};
</script>
